<template>
	<div>
		<div class="title">
			<h5>日志菜单使用说明:</h5>
			<div id="notice">
				<h5>说明:</h5>
				<span>1：日志目前只跟踪登陆、新增、修改、删除操作</span><br>
				<span>2：如果有关键信息遗漏,请联系开发人员添加!</span><br>

			</div>
		</div>

		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>

		<div v-loading="fullloading" element-loading-text="日志抓取中......" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<!-- 动态编辑区生成 -->
			<div class="content_edit">
				<div class="content_edit_item">
					<label> 操作员:</label>
					<input type="text" class="short" v-model="key_user" @keyup.enter="refresh_data( )" />

				</div>
				<div class="content_edit_item">
					<label> 短标题:</label>
					<input type="text" class="short" v-model="key_oper" @keyup.enter="refresh_data() " />

				</div>
				<div class="content_edit_item">
					<label> 编辑内容：</label>
					<input type="text" class="long2" v-model="key_data" @keyup.enter="refresh_data( )" />

				</div>

			</div>

			<table class="dataintable">

				<tr class="tab_header">
					<td style="display:none;">ID</td>
					<td>序号</td>
					<td>操作人</td>
					<td class="long1">操作类型</td>
					<td class="long1">操作对象</td>
					<td>状态</td>
					<td class="long2">操作结果</td>
					<td class="long4">内容</td>
					<td class="long1_2">发布时间</td>
				</tr>

				<tr :id="'log_'+item.row_num" v-for="(item, index) in list_log" :key="index" @click="sel_row(item)">
					<td>{{ item.row_num }}</td>
					<td>
						{{ item.oper_user }}
					</td>
					<td class="long1">{{ item.oper_action }}</td>
					<td v-on:mousemove="show_detaildata($event, item.oper_err, '1')" v-on:mouseout="noshow_detaildata">
						{{ item.oper_object }}</td>
					<td>{{ item.oper_flag }}</td>
					<td v-on:mousemove="show_detaildata($event, item.oper_err, '1')" v-on:mouseout="noshow_detaildata"
						class="long2">
						{{ item.oper_err }}
					</td>
					<td class="long4" v-on:mousemove="show_detaildata($event, item.oper_data, '1')" v-on:mouseout="noshow_detaildata">
						{{item.oper_data}}
					</td>
					<td class="long1_2">{{ item.oper_date }}</td>
				</tr>

			</table>
		</div>

		<!-- 分页部分 -->
		<div class="pre_page" v-show="show_page">
			<ul style="text-align: right; margin-right: 20px;">
				<li>
					当前页：<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp; <a href="#"
						@click="firstpage">首页</a>|
					<a href="#" @click="beforepage">上一页</a>|
					<a href="#" @click="nextpage">下一页</a>|
					<a href="#" @click="lastpage">尾页</a>
					<input type="text" v-model="jumppage" value="" /><a href="#" @click="gopage" class="go">Go</a>
				</li>
			</ul>
		</div>


		<div id="pre_msg_data" style="display:none;"></div>

	</div>
</template>

<script>
	import t from '@/utils/type.js'
	import {
		GetShort,
		ChangeSpecial,
		BackSpecial
	} from '@/utils/localstore.js';
	import {
		Method_DataByPage
	} from '@/utils/loadhttpdata.js';
	import {
		base_decode
	} from '@/utils/base64.js'
	
	import {
		CheckStringToJson
	} from '@/utils/method.js';

	export default {
		components: {
			"pre-button": () => import("../per_old/pre_btn_control.vue")
		},
		data() {
			return {
				fullloading: false,
				/* 业务变量 */
				show_page: true,
				maxpage: '',
				nowpage: '',
				jumppage: '',

				key_user: '',
				/* 查询关键字 */
				key_oper: '',
				/* 查询关键字 */
				key_data: '',
				/* 查询关键字 */

				list_log: [],
				show_note:false

			};
		},
		created: function() {
			this.load_url = t.http_method;
			this.page_num = 1;
			this.loaddata();
		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			// window.addEventListener('scroll', function() {
			//   that.chang_style(); //fixed 行相对位置修正
			// }, false);
			// // 这里只是操作dom
			// window.addEventListener('resize', function() {
			//   that.chang_style(); //fixed 行相对位置修正
			// }, false);
		},
		methods: {
			loaddata: function() {
				this.control = 'control_log';
				this.refresh_data();
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			select_method: function(type) {
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.fun_upd('_del');
						break;
					case 'sel':
						this.refresh_data();
						break;
					case 'sub':
						this.fun_upd('_sub');
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			sel_row: function(parm) {
				// 点击表格切换操作
				// console.log(parm);
				for (var i = 0; i < this.list_log.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_log[i].row_num == parm.row_num) {
						document.getElementById('log_' + parm.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_log[i].row_num % 2 == 0) {
							document.getElementById('log_' + this.list_log[i].row_num).style.background = '#fff';
						} else {
							document.getElementById('log_' + this.list_log[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
			},
			isJson: function isJson(str) {
				try {
					if (typeof JSON.parse(str) == 'object')
						return true;
					return false;
				} catch (e) {
					console.log(e);
					return false;
			
				}
			},
			show_detaildata: function(that, item, type) {
				// 鼠标跟踪显示明细内容
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 '+x+' '+y);
				// console.log(item);
				x = that.clientX + 20;
				y = that.clientY;
				temp_css = "position: fixed;top:" + y + "px;left:" + x +
					"px;background-color: #537bff;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 9;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 240px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
					// console.log('待展示内容',item);
					if(typeof(item)==='object'){
						console.log('json格式')
						document.getElementById("pre_msg_data").innerText = JSON.stringify(item);
					}else{
						let temp_innerHtml = '';
						temp_innerHtml = BackSpecial(item);
						temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")
						
						// console.log(item);
						document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					}
					

					// document.getElementById("pre_msg_data").innerHTML = item.replace(' ','\n');
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			refresh_data: function() {
				console.log('页面=' + this.nowpage);
				this.fullloading = true;
				this.$post(
					t.http_method, Method_DataByPage('data_sys_log', this.nowpage, this.key_user, this.key_oper,
						this
						.key_data)
				).then(res => {
					this.fullloading = false;
					// console.log(res);
					let check_str = '';
					check_str = CheckStringToJson(res);
					// console.log('检查完', check_str);
					try {
						res = JSON.parse(check_str);
						// console.log('转换完', res); // 尝试直接解析
					} catch (error) {
						try {
							// 使用jsonlint尝试解析和清理字符串
							res = jsonlint.parse(check_str); // 注意：jsonlint返回的是解析后的对象，不是字符串						      
						} catch (lintError) {
							throw error; // 如果jsonlint也无法解析，抛出原始错误
						}
					}

					this.maxpage = res.data.allpage;
					if (Number(res.data.allpage) == 0) {
						this.$message({
							message: '没有查询到数据',
							type: 'success'
						});
					} else {
						let t = res.data.data;
						// console.log(t);

						this.list_log = t;
					}


				});
			},
			firstpage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage = 1;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			lastpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage = this.maxpage;
					this.refresh_data();
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			gopage: function() {

				if (Number(this.jumppage) > 0 && Number(this.jumppage) <= Number(this.maxpage)) {
					this.nowpage = this.jumppage;
					this.refresh_data();
				} else {
					this.$message({
						message: '跳转页数不在规定范围内,请检查' + this.jumppage,
						type: 'warning'
					});
				}
			},



		}

	}
</script>
<style scoped>
	.title {
		margin-top: 10px;
	}

	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: bolder;
	}
</style>
